



























































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import QualificationDto from '@/models/Qualifications/QualificationDto'
import GiganautVue from '@/components/Shared/GiganautVue';
import QualificationCreate from '@/components/Qualifications/QualificationCreate.vue';
import QualificationEdit from '@/components/Qualifications/QualificationEdit.vue';

@Component({
  name: 'Qualifications',
  components: { QualificationCreate, QualificationEdit }
})
export default class extends GiganautVue {

    async beforeMount() {
        AgencySettingsModule.updateCurrentQualification(null);
    }

    async updateCurrentQualification(qualification: QualificationDto) {
        AgencySettingsModule.updateCurrentQualification(qualification);
    }

    get currentQualification() {
        return AgencySettingsModule.currentQualification;
    }

    get loadingQualifications() {
        return AgencySettingsModule.loadingQualifications;
    }

    get qualifications() {
        return AgencySettingsModule.qualifications;
    }
}
